"use client";
import "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import o from "./index.es65.js";
import "./index.es24.js";
o.div`
  .bl-accordion:not(.bl-accordion--is-closed) .bl-accordion__content,
  .bl-info-box {
    overflow: visible;
    display: block;
  }
`;
o.div`
  text-align: right;
  a {
    display: inline-block;
  }
`;
//# sourceMappingURL=index.es36.js.map
